import React, { memo } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { buildRedirectTo } from 'src/utils/adminRedirect'

interface Props {
  // A route pattern, which may contain `:params` — interpolated from the current match.
  to: string
}

const QueryPreservingNavigateComponent = ({ to }: Props) => {
  const location = useLocation()
  const params = useParams()

  return <Navigate replace to={buildRedirectTo(to, params, location.search, location.hash)} />
}

export const QueryPreservingNavigate = memo(QueryPreservingNavigateComponent)
